import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import ReactTooltip from 'react-tooltip'

class Notes extends React.Component {
  state = {
    notes: this.props.notes
  }

  deleteNote = (note) => {
    var that = this
    var notes = _.reject(this.state.notes, {id: note.id})

    axios.delete('/notes/' + note.id)
    .then(function (response) {
      toastr.error('Note deleted')
      that.setState({
        notes: notes
      })
    })
    .catch(function (error) {
      toastr.error('Note not deleted')
      console.log(error)
    })
  }

  renderDeleteButton = (note) => {
    var that = this

    if (this.props.current_user_id == note.user_id) {
      return (
        <span>
          <span className='margin-right-five'>
            •
          </span>
          <a tabIndex={0} onClick={function(){that.deleteNote(note)}}
             className='styled-link pointer-hand small-text'
             onKeyDown={(e) => {
              if (e.key === "Enter") {
                that.deleteNote(note);
              }
            }}
             >
            Delete
          </a>
        </span>
      )
    }
  }

  handleChange = (evt) => {
    if (evt.target.value.length > 0) {
      this.setState({ allowNote: true })
    }
    else {
      this.setState({ allowNote: false })
    }

    this.setState({
      newNote: evt.target.value
    })
  }

  addNote = (e) => {
    e.preventDefault()

    var that = this
    var notes = this.state.notes
    this.setState({ newNote: '' })
    this.setState({ allowNote: false})

    axios.post(this.props.post_url, {
      note: {
        user_id: that.props.current_user_id,
        body: that.state.newNote
      }
    })
    .then(function (response) {
      toastr.success('Note added')
      notes.unshift(response.data)
      that.setState({ notes: notes })
    })
    .catch(function (error) {
      toastr.error('Note not added')
      console.log(error)
    })
  }

  renderNewNoteButton = () => {
    const style = {
      width: '100%'
    }

    if (this.state.allowNote) {
      return(
        <button className='btn btn-indigo btn-raised'
           onClick={this.addNote}
           style={style}>
          SAVE
        </button>
      )
    }
    else {
      return(
        <button className='btn btn-indigo btn-raised'
           style={style}
           disabled={!this.state.allowNote} 
           >
          SAVE
        </button>
      )
    }
  }

  renderNewNoteForm = () => {
    return (
      <form onSubmit={this.addNote}>
        <textarea
          rows='3'
          cols='80'
          className='form-control'
          placeholder='Add note...'
          type='text'
          value={this.state.newNote}
          onChange={this.handleChange} />
        {this.renderNewNoteButton()}
      </form>
    )
  }

  renderNotes() {
    var that = this
    var notes = []

    _.forEach(this.state.notes, function(note, index) {
      var createdAtToolTip = moment(note.created_at).format('dddd, MMMM Do YYYY, h:mm:ss A')

      notes.push(
        <span key={index}>
          <p className='grey-text'>
            {note.body}
          </p>
          <span className='grey-text small-text'>
            <a href={'/users/' + note.user.id}
               className='styled-link margin-right-five'>
              {note.user.full_name_reverse}
            </a>
            <span className='margin-right-five'
                  data-tip={createdAtToolTip}>
              {moment(note.created_at).fromNow()}
              <ReactTooltip />
            </span>
            {that.renderDeleteButton(note)}
            <br />
            <hr />
          </span>
        </span>
      )
    })

    return (
      <div className='well shadowDepth1'>
        {this.props.fieldTitle &&
          <h4>
            {this.props.fieldTitle}
          </h4>
        }
        {this.props.fieldSubTitle &&
          <p className='non-signed-in-p'>
            {this.props.fieldSubTitle}
          </p>
        }
        {that.renderNewNoteForm()}
        <hr />
        {notes}
      </div>
    )
  }

  render() {
    return(
      <div>
        {this.renderNotes()}
      </div>
    )
  }
}

Notes.propTypes = {
  current_user_id: PropTypes.number,
  notes: PropTypes.array,
  post_url: PropTypes.string,
  fieldTitle: PropTypes.string,
  fieldSubTitle: PropTypes.string
}

export default Notes
